var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navigation'),_c('MusicIcon',{on:{"player":function (i) {
          _vm.player = i;
        }}}),_c('Return'),_c('transition',{attrs:{"mode":"out-in"}},[_c('keep-alive',[_c('router-view',{attrs:{"player":_vm.player}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }